import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import ExternalLinkIcon from "components/shared/ExternalLinkIcon";
import ExpandingText from "components/ui/ExpandingText";
import { extractDomain } from "lib/htmlTools";
import ListUserReadCountLoader from "components/BookGroup/headers/parts/ListUserReadCountLoader";
import calendar from "icons/solid/calendar.svg";
import Icon from "hardcover-ui/components/Icon";
import TextLink from "hardcover-ui/components/TextLink";
import pluralize from "lib/pluralize";
import ListLinks from "../ListLinks/ListLinks";
import { ListSerializersListByline, UserSerializersUserByline } from "types/serializers";

export interface PageProps {
  list: ListSerializersListByline;
  user: UserSerializersUserByline;
}

export default function ListHeader({ list, user }: PageProps) {
  const { username } = user;

  return (
    <div className="p-4">
      <ListLinks list={list} user={user} />
      <Heading level={1} variant="primary" size="lg" className="mt-2">
        {list.name}
      </Heading>
      <div className="flex flex-col md:flex-row justify-between py-1 md:items-center">
        <ul className="list-bullet flex-grow text-secondary">
          <li className="hidden">
            <Text variant="secondary" size="sm" className="space-x-1">
              <Icon icon={calendar} size="sm" className="-mt-1" />
              <span>Updated {list.updatedAtText} ago</span>
            </Text>
          </li>
          <li>
            <TextLink
              href={`/@${username}/lists/${list.slug}`}
              variant="secondary"
              size="sm"
            >
              {list.booksCount.toLocaleString()}{" "}
              {pluralize("Book", list.booksCount)}
            </TextLink>
          </li>
          {list.url?.length > 0 ? (
            <li>
              <TextLink
                href={list.url}
                variant="secondary"
                underline
                external
                className="space-x-1"
              >
                <ExternalLinkIcon url={list.url} size="sm" />
                <span>{extractDomain(list.url)}</span>
              </TextLink>
            </li>
          ) : (
            false
          )}
        </ul>
        <div className="mt-2 md:mt-0">
          <ListUserReadCountLoader
            listId={list.id}
            count={list.booksCount}
            size="md"
          />
        </div>
      </div>

      {list.description?.length > 0 ? (
        <ExpandingText
          className="mt-4 leading-6 mb-1 lg:mb-2"
          text={list.description}
          lines={3}
        />
      ) : (
        false
      )}
    </div>
  );
}
